import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Data,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {EMPTY, Observable, of} from 'rxjs';
import {I18nService} from "@biletix/core/services/i18n.service";
import {RegionService} from "@biletix/core/services/region.service";
import {AuthenticationService} from "@biletix/core/services/authentication.service";
import {RouterService} from "@biletix/core/services/router.service";
import { CustomerService } from '../services/customer.service';
import { catchError, mergeMap } from 'rxjs/operators';
import { GlobalErrorHandler } from '../services/global-error-handler.service';
import { CustomerAccountService } from '../services/customer-account.service';
import { NotificationService } from '../services/notification.service';
import { ApiResponseStatus } from '../models/api-response-status';
import { LoggedInCustomer } from '../models/authentication/logged-in-customer.model';
import {CustomerPhoneStatus} from "@biletix/core/common/enums/customer-phone-status.enum";

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate, CanActivateChild {

  constructor(private authenticationService: AuthenticationService,
              private customerService: CustomerService,
              private router: Router,
              private regionService: RegionService,
              private routerService: RouterService,
              private i18n: I18nService,
              private globalErrorHandler: GlobalErrorHandler,
              private customerAccountService: CustomerAccountService,
              private notificationService: NotificationService
            ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.getLoggedInCustomer().pipe(
      mergeMap(() => {
        // getLoggedInCustomer sonucuna göre checkLogin çağır
        const isAllowed = this.checkLogin(state.url, route.data);
        return of(isAllowed ? true : this.router.parseUrl(this.routerService.loginUrl));
      }),
      catchError(() => {
        // Hata durumunda giriş sayfasına yönlendir
        return of(this.router.parseUrl(this.routerService.loginUrl));
      })
    );
  }



  checkLogin(url: string, data: Data): boolean {
    this.authenticationService.redirectUrl = url;
    if (this.authenticationService.isAuthenticated()) {
      const loggedInCustomer = this.authenticationService.getLoggedInCustomer()
      const needNewPhone = loggedInCustomer && (loggedInCustomer.phoneVerificationStatus === CustomerPhoneStatus.EMPTY || loggedInCustomer.phoneVerificationStatus === CustomerPhoneStatus.INVALID_NUMBER);
      if (loggedInCustomer && (loggedInCustomer.phoneVerificationStatus === CustomerPhoneStatus.UNVERIFIED
        || needNewPhone)) {

        if (needNewPhone) {
          //this.notificationService.info(this.translate.instant("account.info.phoneShouldChange"));
        }
        this.router.navigate([this.routerService.smsVerificationUrl], {
          queryParams: {returnUrl: this.authenticationService.redirectUrl, needNewPhone: needNewPhone}
        });
      }
      return true;
    }



    const stateObj: any | { returnUrl: string } = {
      returnUrl: url
    };

    if (data && data['showLoginAsAnonymousBtn']) {
      stateObj['showLoginAsAnonymousBtn'] = true;
    }

    this.router.navigate(
      [this.routerService.loginUrl],
      {
        state: stateObj,
        queryParams: stateObj
      }
    );
    return false;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state);
  }


  getLoggedInCustomer(){
   return this.customerService
            .getLoggedInCustomer()
            .pipe(
                catchError((err) => {
                    this.globalErrorHandler.handleError(err);
                    // this.goBack();
                    return EMPTY;
                }),
                mergeMap(response => {

                        //işlem başarılı ise confirmation sayfasına yönlendir
                        if (response && response.status == ApiResponseStatus.SUCCESS) {
                            if(response.data){
                                this.customerAccountService.setLocalCustomer(response.data);
                                //phone and phoneVerificationStatus must fix. Due to it's not in master, not added in BTXWB-1314
                                const loggedInCustomer: LoggedInCustomer = {
                                    customerId: response.data.id,
                                    email: response.data.email,
                                    name: response.data.name + " " + response.data.surname,
                                    anonymous: false,
                                    phone: response.data.mobilePhonePrefix + response.data.mobilePhone,
                                    phoneVerificationStatus: response.data.phoneVerificationStatus
                                }
                                this.authenticationService.setLoggedInCustomer(loggedInCustomer);
                            }
                            return of(response.data);
                        }

                        //show error message
                        this.notificationService.error(response.errors);

                        //TODO: Seam devre dışı kalınca aktif edilecek.
                        // this.routerService.navigateToHomePage()
                        this.routerService.navigateToSeamHomePage();
                        return EMPTY;
                    }
                )
            )
  }

}
